/*
 * post grid structure.
 * Used in another components.
 */
import { CommonModule } from '@angular/common';
import { Component, OnInit, Input, Output, EventEmitter  } from '@angular/core';
import { DynamicContentComponent } from 'app/shared/dynamic-content/dynamic-content.component';

@Component({
  selector: '[angly-postGrid]',
  templateUrl: './postGrid.component.html',
  styleUrls: ['./postGrid.component.scss'],
  standalone: true,
  imports: [ CommonModule, DynamicContentComponent ]
})
export class PostGridComponent implements OnInit {

  /*
   * postGridContent is a attribute.
   */
  @Input() postGridContent: any;

  constructor() { }

  ngOnInit() {
  }

}
